import styles from "./Pagination.module.css"
import Button from "../Button"

const DELTA = 1;

const buildPageWindow = (current, total) => {
  if (total <= 1) return [];

  if (total <= 2 * DELTA + 3) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const siblingsStart = Math.max(
    Math.min(current - DELTA, total - DELTA * 2 - 2),
    3
  );
  const siblingsEnd = Math.min(
    Math.max(current + DELTA, DELTA * 2 + 3),
    total - 2
  );

  const hasLeftEllipsis = siblingsStart > 3;
  const hasRightEllipsis = siblingsEnd < total - 2;

  const pages = [1, hasLeftEllipsis ? '...' : 2];
  for (let p = siblingsStart; p <= siblingsEnd; p++) pages.push(p);
  pages.push(hasRightEllipsis ? '...' : total - 1, total);

  return pages;
};

const Pagination = ({ pagination, compact = false, customClassName, customPageSize, currentPage = 1, onPageChange }) => {
  const pageSize = customPageSize || 24;
  const controlSize = compact ? '44px' : '60px';

  const totalPages = Math.ceil(pagination.count / pageSize);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;

    window.__paginationChanged = true;

    if (onPageChange) {
      onPageChange(newPage);
    }
  };

  const renderPageButtons = () => {
    const pageItems = buildPageWindow(currentPage, totalPages);
    return pageItems.map((item, i) => {
      if (item === '...') {
        return <span key={`ellipsis-${i}`} className={styles.ellipsis}>…</span>;
      }
      return (
        <div key={item} className={styles.pageBtn}>
          <Button
            variant={item === currentPage ? 'blue' : 'transparent'}
            color="blue"
            label={item.toString()}
            labelPosition="center"
            onClick={() => handlePageChange(item)}
          />
        </div>
      );
    });
  };

  return (
<div className={`${styles.container} ${compact ? styles.compact : ''} ${customClassName || ''}`}>
      <div>
        <Button style={{ width: controlSize }}
          iconType="arrowLeft"
          variant={pagination.previous ? 'outline-blue' : 'outline-grey'}
          onClick={() => handlePageChange(currentPage - 1)}
        />
      </div>

      <div className={styles.pages}>
        {renderPageButtons()}
      </div>

      <div>
        <Button style={{ width: controlSize }}
          iconType="arrowRight"
          variant={pagination.next ? 'outline-blue' : 'outline-grey'}
          onClick={() => handlePageChange(currentPage + 1)}
        />
      </div>
    </div>
  );
};

export default Pagination;
